import { Injector } from '@angular/core';
import { EIremboFormlyFieldTypes } from '@irembo-andela/irembogov3-common';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import { getDefaultBaseSettingsConfigFormly } from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  customDynamicRepeaterFieldParseIntoSettingsFormModel,
  customDynamicRepeaterFieldUpdateFromSettingsFormModel,
  defaultCustomDynamicRepeaterConfigFormModel,
} from '../custom-dynamic-repeater-field-type.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomDynamicRepeaterFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = defaultCustomDynamicRepeaterConfigFormModel;
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      {
        key: 'dynamicRepeaterSection',
        wrappers: ['panel-wrapper'],
        props: {
          label: 'Dynamic Repeater Configuration',
          description: 'Configure how API data is mapped to repeater items',
        },
        fieldGroup: [
          {
            key: 'itemIdField',
            type: EIremboFormlyFieldTypes.input,
            props: {
              label: 'Item ID Field',
              placeholder: 'id',
              required: true,
              description:
                'Field name in API data for item ID (supports dot notation, e.g., "user.id")',
            },
          },
          {
            key: 'itemLabelField',
            type: EIremboFormlyFieldTypes.input,
            props: {
              label: 'Item Label Field',
              placeholder: 'label',
              required: true,
              description:
                'Field name in API data for item display text (supports dot notation, e.g., "user.name")',
            },
          },
          {
            key: 'emptyStateMessage',
            type: EIremboFormlyFieldTypes.textarea,
            props: {
              label: 'Empty State Message',
              placeholder: 'No items available',
              rows: 2,
              description: 'Message shown when no items are available',
            },
          },
          {
            key: 'enableDebugLogging',
            type: EIremboFormlyFieldTypes.checkbox,
            props: {
              label: 'Enable Debug Logging',
              formCheck: 'switch',
              description:
                'Enable console logging for development and debugging',
            },
          },
        ],
      },
    ];
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return customDynamicRepeaterFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return customDynamicRepeaterFieldUpdateFromSettingsFormModel(
      model,
      this.field
    );
  }
}
